import React from 'react'
import { Modal, Button, Typography, Steps, Icon, message } from "antd";
import {
    Upload,
    List,
    Spin,
    Card
  } from "antd";
import { useState,useEffect } from 'react';

const { Title } = Typography;
const { Dragger } = Upload;
const { Step } = Steps;
const { Text } = Typography;

import { platformApi } from '../../../../api';


const AddNumberPlating = ({open,close,reloadData, isMultiple=true}) => {

    const [files, setFiles] = useState([]);
    const [csvUrl, setCsvUrl] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [processing, setProcessing] = useState(false);
    const [pollingInterval, setPollingInterval] = useState(null);
    const [selectingFiles, setSelectingFiles] = useState(false); 

    const handleChange = (info) => {
      const { fileList } = info;
    
      if (fileList.length > files.length) {
        setSelectingFiles(true);
      }
    
      setTimeout(() => {
        let validFiles = fileList.filter(file => {
          const isPDF = file.type === 'application/pdf';
          const isLt5M = file.size / 1024 / 1024 < 5;
    
          if (!isPDF) {
            message.error(`${file.name} is not a PDF file.`);
            return false;
          }
          if (!isLt5M) {
            message.error(`${file.name} exceeds 5MB size limit.`);
            return false;
          }
          return true;
        });
    
        if (!isMultiple && validFiles.length > 1) {
          validFiles = [validFiles[validFiles.length - 1]];
          message.info("Only one file can be uploaded at a time.");
        }
    
        setFiles(validFiles);
        setSelectingFiles(false);
      }, 500);
    };
    
      const handleUpload = async () => {
        if (!files.length) {
          close();
          return;
        }
        setUploading(true);
        const formData = new FormData();
      
        files.forEach(file => {
          formData.append('pdfFiles', file.originFileObj || file);
        });
      
        try {
          // Remove `responseType: 'blob'` — backend sends JSON, not blob
          const response = await platformApi.post('/api/numberPlate/upload', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
      
          const { fileStatuses, xlsxBase64 } = response.data;
      
          const allAlreadyUploaded = fileStatuses?.every(
            f => f.status === "Already Uploaded"
          );

          let successCount = 0 , failureCount = 0;

          fileStatuses.map((file)=>{
            file.status === "New" ? successCount++ : failureCount++;
          })
      
          if (xlsxBase64 == null) {
            message.info("All selected files are already uploaded. No new data processed.");
            message.info(`Success: ${successCount}, Failure: ${failureCount}`);
            return;
          }
          
          const xlsxBlob = new Blob(
            [Uint8Array.from(atob(xlsxBase64), c => c.charCodeAt(0))],
            { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
          );
          const xlsxUrl = URL.createObjectURL(xlsxBlob);
          message.success("Processing complete! XLSX file is ready.",`Success: ${successCount}, Failure: ${failureCount}`);
          downloadFile(xlsxUrl);          
      
          setFiles([]);
          !isMultiple && reloadData();
        } catch (error) {
          message.error('Upload failed. Please try again.');
        } finally {
          isMultiple && reloadData();
          close();
          setUploading(false);
        }
      };
    
      useEffect(() => {
        return () => {
          if (pollingInterval) clearInterval(pollingInterval);
        };
      }, [pollingInterval]);
      
      const draggerProps = {
        onChange: handleChange,
        beforeUpload: () => false,
        multiple: isMultiple,
        accept: '.pdf',
        fileList: files,
        onRemove: (file) => {
          setFiles(prev => prev.filter(f => f.uid !== file.uid));
        },
      };
     
    
      const downloadFile = (xlsx) => {
        if (!xlsx) return;
        const now = new Date();
        const timestamp = now.toISOString().slice(0, 19).replace(/[:T]/g, '-').replace('-', '_');
        const uniqueFilename = `vehicle-details-${timestamp}.xlsx`;
        const link = document.createElement('a');
        link.href = xlsx;
        link.setAttribute('download',uniqueFilename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
      
  return (
    <Modal
      width="80%"
      title={"Vehicle Details PDF Upload"}
      visible={open}
      onCancel={() => {
        close();
      }}
      footer={[
        <Button key="cancel" onClick={() => {
          close();
        }}>
          Cancel
        </Button>
      ]}
    >
        <Card className="vehicle-upload-card" bordered={false}>
      <Title level={4} className="upload-title">
        Vehicle Details PDF Upload
      </Title>
      
      <Dragger {...draggerProps} className="upload-dragger">
        {selectingFiles ? (
          <Spin tip="Loading selected files..." size="large" />
        ) : (
          <>
            <p className="ant-upload-drag-icon">
              <Icon type="inbox" />
            </p>
            <p className="ant-upload-text">Click or drag PDF {isMultiple ? "files" : "file"} to this area</p>

            <p className="ant-upload-hint">
              {isMultiple?"Upload multiple vehicle detail PDFs (Max 5MB per file)":"Upload vehicle detail PDF (Max 5MB per file)"}
            </p>
          </>
        )}
      </Dragger>

      <List
        className="file-list"
        dataSource={files}
        renderItem={file => (
          <List.Item>
            <List.Item.Meta
              avatar={<Icon type="file-pdf" style={{ color: '#ff4d4f' }} />}
              title={file.name}
              description={`${(file.size / 1024 / 1024).toFixed(2)} MB`}
            />
          </List.Item>
        )}
      />

      <div className="action-section">
        <Button
          type="primary"
          onClick={handleUpload}
          disabled={files.length === 0 || uploading || processing}
          className="upload-button"
        >
          {uploading ? <Spin indicator={<Icon type="loading" spin />} /> 
            : processing ? 'Processing...' : isMultiple?'Process PDFs':'Process PDF'}
        </Button>

        {processing && (
          <Spin tip="Generating CSV..." style={{ marginLeft: 16 }} />
        )}

      </div>
    </Card>
        </Modal>
  )
}

export default AddNumberPlating;
